import { Component } from '@angular/core';
import { ComAutoCompleteComponent } from '@kv-common-components/kv-common-components';
import { ReferentielService } from '@kv-common-components/kx-services';
@Component({
    selector: 'app-auto-complete-component',
    templateUrl: './auto-complete.component.html',
    styleUrls: ['./auto-complete.component.css'],
})
export class AutoCompleteComponent extends ComAutoCompleteComponent {
    constructor(protected referentielService: ReferentielService) {
        super(referentielService);
    }
}
